<template>
  <div class="columns is-mobile is-centered is-vcentered is-full-height">
      <div class="column">
          <div class="columns is-mobile is-centered">
              <div class="column is-two-thirds has-text-centered">
                  <img id="logo" :src="`${publicPath}img/logo.png`" alt="eWATER Services">
              </div>
          </div>
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <div class="columns is-mobile is-centered">
              <div class="column is-one-third">
                  <a href="https://accounts.ewater.services/login?redirect" class="button is-primary is-fullwidth">
                      <span class="icon">
                          <i class="fa fa-lock"></i>
                      </span>
                      <span>{{ $t("Login") }}</span>
                  </a>
              </div>
              <div class="column is-one-third">
                  <a :href="`${process.env.VUE_APP_ACCOUNTS_URL}/register?redirect`" class="button is-info is-fullwidth">
                      <span class="icon">
                          <i class="fa fa-user"></i>
                      </span>
                      <span>{{ $t("SignUp") }}</span>
                  </a>
              </div>
          </div>
          <div class="columns is-mobile is-centered">
              <div class="column is-two-thirds">
                  <div class="control has-icons-left">
                      <div class="select is-fullwidth">
                          <select v-model="language" @change="switchLanguage()">
                              <option selected value="disabled" disabled>{{ $t("Language") }}</option>
                              <option value="en">{{ $t("English") }}</option>
                              <option value="sw">{{ $t("Swahili") }}</option>
                          </select>
                      </div>
                      <div class="icon is-small is-left">
                          <i class="fa fa-flag"></i>
                      </div>
                  </div>
              </div>
          </div>
          <p class="has-text-grey-light has-text-centered is-size-7">{{ $t("Version") }}: {{ version }}</p>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Notification from "@/components/Notification.vue";

export default {
  name: "Index",
  components: {
    Notification
  },
  data () {
      return {
          language: "disabled"
      }
  },
  methods: {
    switchLanguage: function()
    {
      this.updateTranslations(this.language);
    }
  }
};
</script>
